// Maps warm stages/states and the time-escalating wait copy to i18n message
// keys. Pure — no React.
import type { MessageKey } from "../i18n/en";
import type { WarmStage, WarmState } from "@shared/warm-progress";

const STAGE_KEY: Record<Exclude<WarmStage, "ready">, MessageKey> = {
  election: "loader.stage.election",
  country: "loader.stage.country",
  history: "loader.stage.history",
  candidates: "loader.stage.candidates",
};

export function stageLabelKey(stage: Exclude<WarmStage, "ready">): MessageKey {
  return STAGE_KEY[stage];
}

/** Copy for a forecast status: a progress stage label, the rate-limit / busy
 * message for transient upstream conditions, or null once "ready" (done). */
export function stateMessageKey(state: WarmState): MessageKey | null {
  if (state === "rate_limited") return "loader.state.rateLimited";
  if (state === "busy") return "loader.state.busy";
  if (state === "ready") return null;
  return stageLabelKey(state);
}

/** Time-escalating wait copy for slow fetches with no real progress signal:
 * a calm line first, escalating to "WarEra's busy" the longer it drags. */
export interface WaitStep {
  afterMs: number;
  key: MessageKey;
}
export const WAIT_STEPS: WaitStep[] = [
  { afterMs: 0, key: "loader.wait.contacting" },
  { afterMs: 4000, key: "loader.wait.fetching" },
  { afterMs: 12000, key: "loader.wait.slow" },
];

export function waitMessageKey(elapsedMs: number): MessageKey {
  let key = WAIT_STEPS[0].key;
  for (const step of WAIT_STEPS) if (elapsedMs >= step.afterMs) key = step.key;
  return key;
}
